// Auto-generated TypeScript enum from PHP enum

export type VariableType = 'boolean' | 'color' | 'component_reference' | 'content' | 'date' | 'datetime' | 'dictionary' | 'domain_reference' | 'dynamic' | 'email' | 'email_layout_reference' | 'event_schedule' | 'field_reference' | 'file_reference' | 'filter' | 'form' | 'guard' | 'identity' | 'liquid' | 'list' | 'location' | 'markdown' | 'money' | 'notification_template_reference' | 'notification_type_reference' | 'null' | 'number' | 'package_input_reference' | 'page_reference' | 'password' | 'phone' | 'point' | 'record' | 'record_reference' | 'recurrence' | 'regular_hours' | 'relation' | 'resolver' | 'resource_field_key_reference' | 'resource_field_value' | 'resource_reference' | 'role_reference' | 'schema' | 'select' | 'text' | 'time' | 'timezone' | 'unknown' | 'url' | 'uuid' | 'wallet_accounting_account' | 'wallet_accounting_entity' | 'workflow_reference' | 'workflow_state_variable_reference' | 'workflow_step_reference';

export const VariableType = {
  Boolean: 'boolean' as const,
  Color: 'color' as const,
  ComponentReference: 'component_reference' as const,
  Content: 'content' as const,
  Date: 'date' as const,
  Datetime: 'datetime' as const,
  Dictionary: 'dictionary' as const,
  DomainReferenceVariable: 'domain_reference' as const,
  Dynamic: 'dynamic' as const,
  Email: 'email' as const,
  EmailLayoutReference: 'email_layout_reference' as const,
  EventSchedule: 'event_schedule' as const,
  FieldReference: 'field_reference' as const,
  FileReferenceVariable: 'file_reference' as const,
  Filter: 'filter' as const,
  Form: 'form' as const,
  Guard: 'guard' as const,
  Identity: 'identity' as const,
  Liquid: 'liquid' as const,
  List: 'list' as const,
  Location: 'location' as const,
  Markdown: 'markdown' as const,
  Money: 'money' as const,
  NotificationTemplateReference: 'notification_template_reference' as const,
  NotificationTypeReference: 'notification_type_reference' as const,
  Null: 'null' as const,
  Number: 'number' as const,
  PackageInputReference: 'package_input_reference' as const,
  PageReference: 'page_reference' as const,
  Password: 'password' as const,
  Phone: 'phone' as const,
  Point: 'point' as const,
  Record: 'record' as const,
  RecordReference: 'record_reference' as const,
  Recurrence: 'recurrence' as const,
  RegularHours: 'regular_hours' as const,
  Relation: 'relation' as const,
  Resolver: 'resolver' as const,
  ResourceFieldKeyReference: 'resource_field_key_reference' as const,
  ResourceFieldValue: 'resource_field_value' as const,
  ResourceReference: 'resource_reference' as const,
  RoleReference: 'role_reference' as const,
  Schema: 'schema' as const,
  Select: 'select' as const,
  Text: 'text' as const,
  Time: 'time' as const,
  Timezone: 'timezone' as const,
  Unknown: 'unknown' as const,
  Url: 'url' as const,
  Uuid: 'uuid' as const,
  WalletAccountingAccount: 'wallet_accounting_account' as const,
  WalletAccountingEntity: 'wallet_accounting_entity' as const,
  WorkflowReferenceVariable: 'workflow_reference' as const,
  WorkflowStateVariableReference: 'workflow_state_variable_reference' as const,
  WorkflowStepReferenceVariable: 'workflow_step_reference' as const,
} as const;

export const VariableTypeUtils = {
  values: Object.values(VariableType),
  keys: Object.keys(VariableType) as Array<keyof typeof VariableType>,
  entries: Object.entries(VariableType) as Array<[keyof typeof VariableType, VariableType]>,
  isValid: (value: any): value is VariableType => Object.values(VariableType).includes(value),
  fromKey: (key: keyof typeof VariableType): VariableType => VariableType[key],
};

